var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg9Mobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 426,
    viewBox: "0 0 360 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_454_110042)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.955,
    cy: 230.5,
    rx: 158.955,
    ry: 230.5,
    transform: "matrix(0.810786 0.585342 -0.799372 0.600837 261.5 231.928)",
    fill: "url(#paint0_linear_454_110042)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_454_110042)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.955,
    cy: 230.5,
    rx: 158.955,
    ry: 230.5,
    transform: "matrix(0.810786 0.585342 -0.799372 0.600837 344.312 86)",
    fill: "url(#paint1_linear_454_110042)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_454_110042",
    x: -168.75,
    y: 146.602,
    width: 749.75,
    height: 633.725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_454_110042"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_454_110042",
    x: -85.9375,
    y: 0.673828,
    width: 749.75,
    height: 633.725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_454_110042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_454_110042",
    x1: 158.955,
    y1: 0,
    x2: 158.955,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.59
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_454_110042",
    x1: 158.955,
    y1: 0,
    x2: 158.955,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434BEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434BEE",
    stopOpacity: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg9Mobile);
export default __webpack_public_path__ + "static/media/bg9-mobile.6e66d1eed881ea50d18c71b43824c08d.svg";
export { ForwardRef as ReactComponent };